import script from "./report-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-list.vue?vue&type=script&lang=ts&setup=true"

import "./report-list.vue?vue&type=style&index=0&id=df0d6b7a&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0d6b7a"]])

export default __exports__